import {
  addressSchema,
  contactInfoSchema,
  locationDetailsSchema,
} from "./validation";
import * as Yup from "yup";

const today = new Date().toISOString().split("T")[0];

export const selfPickupSchema = Yup.object({
  pickupAddress: Yup.object({
    ...contactInfoSchema.fields,
    ...addressSchema.fields,
    ...locationDetailsSchema.fields,

    startDate: Yup.string()
      .required("Start date is required")
      .test(
        "not-in-past",
        "Start date cannot be in the past",
        (value) => !value || value >= today,
      ),
    endDate: Yup.string()
      .required("End date is required")
      .test(
        "after-start",
        "End date cannot be before start date",
        function (value) {
          const { startDate } = this.parent;
          return !value || !startDate || value >= startDate;
        },
      ),
    timeSlot: Yup.string().required("Time slot is required"),

    pickupNotes: Yup.string().required("Pickup notes are required"),
  }),

  pickup: Yup.object({
    type: Yup.string().required("Pickup type is required"),

    vehicleInfo: Yup.object({
      vehicleType: Yup.string().required("Vehicle type is required"),
      registrationNumber: Yup.string().required(
        "Vehicle registration is required",
      ),
      driverName: Yup.string().required("Driver name is required"),
      driverPhone: Yup.string().required("Driver phone is required"),
      carrier: Yup.string().required("Carrier is required"),
      confirmationNumber: Yup.string().required(
        "Confirmation number is required",
      ),
      consignmentNote: Yup.string().required("Consignment note is required"),
    }),
  }),

  billingAddress: Yup.object({
    ...contactInfoSchema.fields,
    ...addressSchema.fields,
    landMark: Yup.string().optional(),
    email: Yup.string().required("Email is required"),
  }),
});
